<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-group">
        <div class="group-one" style="width: 220px">
          <a-range-picker
              v-model:value="rangePicker"
              :allowClear="false"
              :ranges="ranges"
              @change="handlePicker"
          />
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.mid"
              :dropdownMatchSelectWidth="false"
              :filterOption="tasknumberFilter"
              :maxTagCount="1"
              placeholder="被分配人"
              show-search
              @change="getTableData"
          >
            <a-select-option
                v-for="(item, index) in searchList.taskmember.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.type"
              placeholder="类型"
              @change="getTableData"
          >
            <a-select-option
                v-for="(item, index) in searchList.tasktype.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.status"
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option
                v-for="(item, index) in searchList.taskstatus.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.hname"
            :loading="searchLoading"
            placeholder="请输入房间名称"
            @search="getTableData"
        >
        </a-input-search>
      </div>
      <div class="lef-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
    <div class="bar-rig">
      <!-- <div class="rig-one">
          <a-button><user-outlined />成员</a-button>
        </div> -->
    </div>
  </div>

  <!-- 表格 -->
  <div v-if="!searchLoading" class="calendar">
    <div class="table">
      <div class="table-left">
        <div class="left-top">
          <div class="top-box">人员</div>
        </div>
        <div class="left-bom f-c-000">
          <div
              id="left-bom"
              :style="{ maxHeight: tableHeight - 20 + 'px' }"
              style="overflow-y: auto"
              @scroll="handleScroll($event, 1)"
          >
            <div
                v-for="(item, index) in table.left_list"
                :key="index"
                class="bom-box"
            >
              <div class="box-date">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-scroll">
        <div
            id="table-scroll"
            :style="{ width: tableWidth - 100 + 'px' }"
            style="display: inline-block; white-space: nowrap; overflow: auto"
        >
          <div class="table-right">
            <div class="right-top">
              <div class="top-box">
                <div
                    v-for="(item, index) in table.top_list"
                    :key="index"
                    class="box-grid f-c-999"
                >
                  <div>
                    {{ item.date }}
                  </div>
                  <div
                      v-if="item.isToday"
                      id="today"
                      class="f-c-green f-w-b"
                      style="width: 100%; text-align: center"
                  >
                    今日
                  </div>
                  <div v-else>
                    <text
                        v-if="item.week == '六' || item.week == '日'"
                        class="f-c-red"
                    >{{ item.week }}
                    </text
                    >
                    <text v-else>{{ item.week }}</text>
                  </div>
                  <div v-if="item.tag" class="tag f-12">
                    {{ item.tag }}
                  </div>
                </div>
              </div>
            </div>
            <div class="right-bom">
              <div
                  id="right-bom"
                  :style="{ height: tableHeight + 'px' }"
                  style="overflow-y: auto"
                  @scroll="handleScroll($event, 2)"
              >
                <div
                    v-for="(item, index) in table.content"
                    :key="index"
                    class="bom-cell"
                >
                  <div
                      v-for="(itemc, indexc) in item.calendar"
                      :key="indexc"
                      class="cell-grid"
                  >
                    <div v-if="typeof itemc.list == 'object'" class="f-12">
                      <div
                          v-for="(itemcc, indexcc) in itemc.list"
                          :key="indexcc"
                      >
                        <div
                            :style="{ color: getBgc(itemcc) }"
                            class="cell-one"
                            @click="handleGoDetails(itemcc)"
                        >
                          {{ itemcc.type_text }}-{{ itemcc.time }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      {{ itemc.list }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else :style="{ maxHeight: tableHeight + 'px' }" class="empty">
    <a-spin size="large"/>
  </div>

  <!-- 弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :title="modalTitle"
      :width="800"
      :zIndex="1001"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 6 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <div class="add-box">
        <div class="add-lef">
          <a-form-item label="类型：" name="type">
            <a-select
                v-model:value="addForm.type"
                placeholder="类型"
                style="width: 100%"
            >
              <a-select-option
                  v-for="(item, index) in searchList.tasktype.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="房间：">
            <a-select
                v-model:value="addForm.hid"
                :allowClear="modalTitle == '创建任务'"
                :filter-option="false"
                placeholder="请选择房间（可选）"
                show-search
                style="width: 100%"
                @change="changeRoom"
                @focus="searchRoom"
                @search="roomFilter"
            >
              <a-select-option
                  v-for="(item, index) in roomList"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="日期：" name="date">
            <a-date-picker
                v-model:value="addForm.date"
                style="width: 100%"
                valueFormat="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item label="时间：" name="time">
            <a-time-picker
                v-model:value="addForm.time"
                format="HH:mm"
                style="width: 100%"
                valueFormat="HH:mm"
            />
          </a-form-item>
          <a-form-item label="被分配人：">
            <a-select
                v-model:value="addForm.mid"
                :allowClear="modalTitle == '创建任务'"
                :filterOption="tasknumberFilter"
                placeholder="被分配人(可选)"
                show-search
            >
              <a-select-option
                  v-for="(item, index) in searchList.taskmember.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
              v-if="addForm.type == 1"
              label="保洁等级："
              name="clean_level"
          >
            <a-select
                v-model:value="addForm.clean_level"
                placeholder="请选择保洁等级"
                @change="changeCleanlevel"
            >
              <a-select-option :value="1">简单</a-select-option>
              <a-select-option :value="2">标准</a-select-option>
              <a-select-option :value="3">高级</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="费用：" name="amount">
            <a-input-number
                v-model:value="addForm.amount"
                placeholder="请输入费用"
                style="width: 100%"
            >
            </a-input-number>
          </a-form-item>
          <div
              v-if="addForm.amount && modalTitle == '创建任务'"
              class="checkbox"
          >
            <a-checkbox v-model:checked="addForm.check">计入收支</a-checkbox>
          </div>
          <a-form-item v-if="addForm.check" label="支付方式：" name="pay_id">
            <a-select
                v-model:value="addForm.pay_id"
                placeholder="请选择支付方式"
            >
              <a-select-option
                  v-for="(item, index) in searchList.paytype.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
        </div>
        <div class="add-rig">
          <a-form-item label="描述：" name="remark">
            <a-textarea
                v-model:value="addForm.remark"
                :rows="4"
                placeholder="请输入描述（可选）"
            />
          </a-form-item>
          <a-form-item label="附件：">
            <a-upload
                :action="action"
                :data="formData"
                :headers="header"
                :show-upload-list="false"
                class="avatar-uploader"
                list-type="picture-card"
                name="image"
                @change="handleChange"
            >
              <img
                  v-if="addForm.image"
                  :src="addForm.image"
                  alt="avatar"
                  fit="fill"
                  style="width: 133px; height: 100px"
              />
              <div v-else>
                <loading-outlined v-if="uploadLoading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">选择图片</div>
              </div>
            </a-upload>
          </a-form-item>
        </div>
      </div>
    </a-form>
  </a-modal>

  <!-- 详情抽屉 -->
  <a-drawer
      v-model:visible="visibleDrawer"
      :bodyStyle="{ padding: 0 }"
      :closable="false"
      class="drawer"
      placement="right"
      style="color: #000000"
      width="500"
  >
    <div class="header">
      <div v-if="detailsData.type == 1" class="title f-w-b f-16">保洁任务</div>
      <div v-else-if="detailsData.type == 2" class="title f-w-b f-16">
        维护任务
      </div>
      <div v-else-if="detailsData.type == 3" class="title f-w-b f-16">
        接待任务
      </div>
      <div v-else-if="detailsData.type == 4" class="title f-w-b f-16">
        客房服务
      </div>
      <div v-else-if="detailsData.type == 5" class="title f-w-b f-16">其他</div>
      <div
          v-if="detailsData.status == 1"
          class="bar"
          style="background-color: #009999"
      >
        待分配
      </div>
      <div
          v-else-if="detailsData.status == 2"
          class="bar"
          style="background-color: #0094ff"
      >
        待执行
      </div>
      <div
          v-else-if="detailsData.status == 3"
          class="bar"
          style="background-color: #ff9900"
      >
        进行中
      </div>
      <div
          v-else-if="detailsData.status == 4"
          class="bar"
          style="background-color: #333333"
      >
        已完成
      </div>
      <div v-else class="bar" style="background-color: #7f7f7f">已取消</div>
    </div>
    <div class="content">
      <!-- 基础信息 -->
      <div class="title f-w-b">基础信息</div>
      <div class="info">
        <div class="lef f-c-999">被分配人：</div>
        <div class="rig">
          {{ detailsData.mname ? detailsData.mname : "-" }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">时间：</div>
        <div class="rig">{{ detailsData.date }} {{ detailsData.time }}</div>
      </div>
      <div class="info">
        <div class="lef f-c-999">房间：</div>
        <div class="rig">
          {{ detailsData.hname ? detailsData.hname : "-" }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">费用：</div>
        <div class="rig">
          <span style="margin-right: 10px">¥{{ detailsData.amount }}</span>
          <template v-if="detailsData.type == 1">
            <span v-if="detailsData.clean_level == 1">简单</span>
            <span v-else-if="detailsData.clean_level == 2">标准</span>
            <span v-else-if="detailsData.clean_level == 3">高级</span>
          </template>
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">任务描述：</div>
        <div class="rig">
          {{ detailsData.remark ? detailsData.remark : "-" }}
        </div>
      </div>
      <!-- 附件 -->
      <div v-if="detailsData.rela.length" class="title f-w-b">附件</div>
      <div class="info">
        <a-image
            v-for="(item, index) in detailsData.rela"
            :key="index"
            :src="imgCut(item.url, 'xl')"
            alt="房源图片"
            fit="fill"
            style="
            width: 80px;
            height: 50px;
            object-fit: cover;
            margin: 0 10px 10px 0;
          "
        />
      </div>

      <!-- 日志 -->
      <div
          v-for="(item, index) in detailsData.log"
          :key="index"
          class="f-12"
          style="margin-bottom: 6px"
      >
        <div>{{ item.remark }}</div>
        <div class="f-c-999">{{ item.create_time }}</div>
      </div>
      <div style="height: 60px"></div>

      <!-- 操作 -->
      <div class="operate">
        <div class="lef">
          <a-button
              v-if="detailsData.status == 1 || detailsData.status == 2"
              class="btn-primary"
              @click="handleEdit"
          >修改任务
          </a-button
          >
        </div>
        <div class="rig">
          <a-button danger type="link" @click="handleDelTask"
          >删除任务
          </a-button
          >
          <a-button
              v-if="
              detailsData.status == 1 ||
              detailsData.status == 2 ||
              detailsData.status == 3
            "
              class="btn-info"
              @click="handleCancelTask"
          >取消任务
          </a-button
          >
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {
  getHouseList,
  getSearchList,
  taskAdd,
  taskCalendar,
  taskCancel,
  taskCleanFeeList,
  taskDel,
  taskDetails,
  taskEdit,
  taskMemberList,
} from "@/api/api";
import {ExclamationCircleOutlined, LoadingOutlined, PlusOutlined,} from "@ant-design/icons-vue";
import dayjs from "dayjs";
import useUtils from "@/hooks/useUtils.js"; //工具库
import {message, Modal} from "ant-design-vue";
import {verifyPrice} from "@/common/validator";
import store from "@/store/pms/landlord/index";
import { baseRequestUrl } from "../../../../config.js";

export default {
  components: {
    LoadingOutlined,
    PlusOutlined,
  },
  setup() {
    let {countTable, imgCut} = useUtils();
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        hname: "",
        mid: [],
        status: [],
        type: [],
        start_date: dayjs().subtract(15, "day").format("YYYY-MM-DD"),
        end_date: dayjs().add(20, "day").format("YYYY-MM-DD"),
        start: 0,
        limit: 999,
      },
      rangePicker: [dayjs().subtract(15, "day"), dayjs().add(20, "day")],
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
        taskmember: {},
        taskstatus: {},
        tasktype: {},
      },
      ranges: {
        昨天: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, "day"), dayjs().add(1, "day")],
        最近7天: [dayjs().subtract(7, "day"), dayjs()],
        最近30天: [dayjs().subtract(30, "day"), dayjs()],
        上月: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
        本月: [dayjs().startOf("month"), dayjs().endOf("month")],

        上季度: [
          dayjs().startOf("month").add(-1, "year").month(9),
          dayjs().endOf("month").add(-1, "year").month(11),
        ],
        本季度: [
          dayjs().startOf("month").month(0),
          dayjs().endOf("month").month(2),
        ],
      },
      getSearchData() {
        if (!search.searchList.length) {
          getSearchList().then((res) => {
            search.searchList = res.data;
          });
        }
      },
      handlePicker(_params, value) {
        search.searchForm.start_date = value[0];
        search.searchForm.end_date = value[1];
        table.getTableData();
      },
      handleReset() {
        search.searchForm.hname = "";
        search.searchForm.start_date = dayjs()
            .subtract(15, "day")
            .format("YYYY-MM-DD");
        search.searchForm.end_date = dayjs()
            .add(20, "day")
            .format("YYYY-MM-DD");
        search.searchForm.mid = [];
        search.searchForm.status = [];
        search.searchForm.type = [];
        search.rangePicker = [
          dayjs().subtract(15, "day"),
          dayjs().add(20, "day"),
        ];
        table.getTableData();
      },
      tasknumberFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    const table = reactive({
      tableHeight: "",
      tableWidth: "",
      table: [],
      getTableData() {
        search.searchLoading = true;
        taskCalendar(search.searchForm).then((res) => {
          table.table = res.data;
          search.searchLoading = false;
          let s = 0;
          for (let item of table.table.top_list) {
            if (!item.isToday) {
              s += 1;
            } else {
              break;
            }
          }
          if (s == 0) {
            nextTick(() => {
              document.getElementById("table-scroll").scrollLeft = 0;
            });
          } else {
            nextTick(() => {
              document.getElementById("table-scroll").scrollLeft = s * 100;
            });
          }
        });
      },
      // 滚动联动
      handleScroll(e, s) {
        if (s == 1) {
          document.getElementById("right-bom").scrollTop =
              document.getElementById("left-bom").scrollTop;
        } else if (s == 2) {
          document.getElementById("left-bom").scrollTop =
              document.getElementById("right-bom").scrollTop;
        }
      },
      getBgc(item) {
        if (item.status == 1) {
          return "#009999";
        } else if (item.status == 2) {
          return "#0099ff";
        } else if (item.status == 3) {
          return "#ff9900";
        } else if (item.status == 4) {
          return "#333333";
        } else {
          return "#7f7f7f";
        }
      },
      handleGoDetails(item) {
        details.getTaskDetail(item.id);
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleAdd: false,
      handleOpenModal() {
        modal.addForm.mid = [];
        modal.addForm.hid = [];
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.modalTitle = "创建任务";
        modal.visibleAdd = true;
      },
      changeCleanlevel() {
        if (modal.addForm.clean_level == 1) {
          modal.addForm.amount = modal.price.clean_easy
              ? modal.price.clean_easy
              : modal.addForm.amount;
        } else if (modal.addForm.clean_level == 2) {
          modal.addForm.amount = modal.price.clean_norm
              ? modal.price.clean_norm
              : modal.addForm.amount;
        } else if (modal.addForm.clean_level == 3) {
          modal.addForm.amount = modal.price.clean_expert
              ? modal.price.clean_expert
              : modal.addForm.amount;
        }
      },
      changeRoom() {
        if (modal.addForm.type == 1) {
          taskMemberList({
            hid: modal.addForm.hid,
            status: 1,
          }).then((res) => {
            modal.addForm.mid = res.data.list[0].id;
            search.searchList.taskmember = res.data;
          });
          taskCleanFeeList({
            hids: modal.addForm.hid,
          }).then((res) => {
            modal.price.clean_norm = res.data.list[0].clean_norm;
            modal.price.clean_expert = res.data.list[0].clean_expert;
            modal.price.clean_easy = res.data.list[0].clean_easy;
            switch (modal.addForm.clean_level) {
              case 1:
                modal.addForm.amount = modal.price.clean_easy;
                break;
              case 2:
                modal.addForm.amount = modal.price.clean_norm;
                break;
              case 3:
                modal.addForm.amount = modal.price.clean_expert;
                break;
            }
          });
        }
      },
      formRef: "", //表单验证
      price: {
        clean_norm: "",
        clean_expert: "",
        clean_easy: "",
      },
      addForm: {
        type: 1,
        date: "",
        time: "",
        mid: [],
        hid: [],
        amount: "",
        pay_id: [],
        clean_level: 1,
        remark: "",
        check: false,
        image: "",
      },
      rules: {
        type: [
          {
            required: true,
            message: "请输入房型名称",
            trigger: "blur",
            type: "number",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        clean_level: [
          {
            required: true,
            message: "请选择保洁等级",
            trigger: "change",
            type: "number",
          },
        ],
        amount: [
          {
            required: true,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: false,
            message: "请输入描述",
            trigger: "blur",
          },
        ],
        pay_id: [
          {
            required: true,
            message: "请选择支付方式",
            trigger: "change",
            type: "number",
          },
        ],
      },

      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        if (modal.modalTitle == "创建任务") {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            let obj = JSON.parse(JSON.stringify(modal.addForm));
            if (obj.check) {
              obj.pay_id = typeof obj.pay_id === "object" ? "" : obj.pay_id;
            } else {
              obj.pay_id = "";
            }
            obj.mid = typeof obj.mid === "object" ? "" : obj.mid;
            obj.hid = typeof obj.hid === "object" ? "" : obj.hid;
            taskAdd(obj)
                .then((res) => {
                  message.success(res.msg);
                  nextTick(() => {
                    modal.isLoading = false;
                  });
                  modal.visibleAdd = false;
                  table.getTableData();
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          });
        } else {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            let obj = {};
            obj.task_id = modal.addForm.id;
            obj.type = modal.addForm.type;
            obj.date = modal.addForm.date;
            obj.time = modal.addForm.time;
            obj.amount = modal.addForm.amount;
            obj.clean_level = modal.addForm.clean_level;
            obj.remark = modal.addForm.remark;
            obj.image = modal.addForm.image;
            if (modal.addForm.check) {
              obj.pay_id =
                  typeof modal.addForm.pay_id === "object"
                      ? ""
                      : modal.addForm.pay_id;
            } else {
              obj.pay_id = "";
            }
            obj.mid =
                typeof modal.addForm.mid === "object" ? "" : modal.addForm.mid;
            obj.hid =
                typeof modal.addForm.hid === "object" ? "" : modal.addForm.hid;
            taskEdit(obj)
                .then((res) => {
                  message.success(res.msg);
                  nextTick(() => {
                    modal.isLoading = false;
                  });
                  modal.visibleAdd = false;
                  table.getTableData();
                  details.getTaskDetail(obj.task_id);
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          });
        }
      },
      roomList: [],
      searchRoom() {
        // if (modal.roomList.length == 0) {
        getHouseList({
          start: 0,
          limit: 99,
        }).then((res) => {
          modal.roomList = res.data.list;
        });
        // }
      },
      throttle: false,
      throttleInput: "",
      roomFilter(input) {
        modal.throttleInput = input;
        if (modal.throttle) {
          return;
        }
        modal.throttle = true;
        setTimeout(() => {
          getHouseList({
            start: 0,
            limit: 99,
            name: modal.throttleInput,
          }).then((res) => {
            modal.roomList = res.data.list;
            modal.throttle = false;
          });
        }, 1000);
      },
      // 上传
      uploadLoading: false,
      action:
          baseRequestUrl + "/h5/upload/uploadImg" +
          "?info=" +
          JSON.parse(sessionStorage.getItem("landlordInfo")).info,
      header: {
        token: JSON.parse(sessionStorage.getItem("landlordInfo")).token,
        version: "1.0.0",
        source: "2",
      },
      formData: {
        module: "pms",
        type: "logo",
      },
      handleChange(info) {
        if (info.file.status === "uploading") {
          modal.uploadLoading = true;
          return;
        }
        if (info.file.status === "done") {
          modal.addForm.image = info.file.response.data.url;
          modal.uploadLoading = false;
          modal.formRef.validate("image");
        }
        if (info.file.status === "error") {
          modal.uploadLoading = false;
          message.error("上传错误");
        }
      },
    });

    // 详情
    const details = reactive({
      visibleDrawer: false,
      detailsData: {
        rela: [],
      },
      getTaskDetail(id) {
        details.visibleDrawer = true;
        taskDetails({
          task_id: id,
        }).then((res) => {
          details.detailsData = res.data.details;
        });
      },
      handleEdit() {
        modal.searchRoom();
        modal.modalTitle = "修改任务";
        nextTick(() => {
          let obj = JSON.parse(JSON.stringify(details.detailsData));
          obj.hid = obj.hid ? obj.hid : [];
          obj.mid = obj.mid ? obj.mid : [];
          Object.assign(modal.addForm, obj);
        });
        modal.visibleAdd = true;
      },
      handleDelTask() {
        Modal.confirm({
          title: "确定删除此任务？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            taskDel({task_id: details.detailsData.id}).then((res) => {
              message.success(res.msg);
              details.visibleDrawer = false;
              table.getTableData();
            });
          },
        });
      },
      handleCancelTask() {
        Modal.confirm({
          title: "确定取消此任务？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            taskCancel({task_id: details.detailsData.id}).then((res) => {
              message.success(res.msg);
              details.visibleDrawer = false;
              table.getTableData();
            });
          },
        });
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom);
        }
    );

    onMounted(() => {
      search.getSearchData();
      table.getTableData();
      table.tableHeight = countTable(search.topDom);
      table.tableWidth = search.topDom.clientWidth;
    });

    return {
      dayjs,
      imgCut,
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(details),
      ...toRefs(modal),
    };
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  // position: absolute;
  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.table {
  display: flex;

  .table-left {
    box-shadow: 0 0 2px #99999999;
    // border-right: 1px solid #c4c4c4;
    z-index: 99;

    .left-top {
      background-color: #f6f6f6;

      .top-box {
        display: flex;
        align-items: center;
        width: 100px;
        height: 50px;
        padding: 0 15px;
      }
    }

    .left-bom ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .left-bom {
      // height: 86%;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */

      .bom-box {
        display: flex;
        width: 100px;
        height: 50px;

        .box-date {
          width: 100%;
          height: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
          line-height: 50px;
          padding: 0 15px;
        }
      }

      .bom-box:nth-child(even) {
        background-color: #f2f2f2;
      }
    }
  }

  .table-scroll {
    .table-right {
      height: 100%;

      .right-top {
        .top-box {
          display: inline-flex;

          .box-grid {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 50px;
            background-color: #f6f6f6;
            position: relative;

            .tag {
              position: absolute;
              top: 5px;
              right: 10px;
              background-color: #da0000;
              color: #ffffff;
              border-radius: 100%;
              width: 15px;
              height: 15px;
              line-height: 15px;
              text-align: center;
            }
          }
        }
      }

      .right-bom {
        display: inline-flex;

        .bom-cell {
          display: flex;

          .cell-grid {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 100px;
            height: 50px;
            // overflow: auto;
            .cell-one:hover {
              //   color: #da0000 !important;
              cursor: pointer;
              text-decoration: underline;
            }

            &:active {
              color: #aaaaaa;
            }
          }
        }

        .bom-cell:nth-child(even) {
          background-color: #f2f2f2;
        }
      }
    }
  }
}
</style>
